import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HomeCategories() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">分类导航</h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">按需查找您需要的域名信息与服务指南</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg mb-4 ${
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                cat.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-base">{cat.name}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{cat.description}</p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="whitespace-nowrap">查看详情</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}